import { mapState } from 'vuex'
const BASE_MIXIN = {
  computed: {
    ...mapState(['userInfo', 'shareConfig', 'follw', 'wxConfig', 'isOpenVipConfig'])
  }
}

export default BASE_MIXIN



// WEBPACK FOOTER //
// ./src/mixins/index.js